import { type FC } from "react";

import "./SelectButtons.scss";

interface SelectButtonsContainerProps {
  children?: React.ReactNode;
}

export const SelectButtonsContainer: FC<SelectButtonsContainerProps> = ({
  children,
}) => {
  return <div className="select-buttons-container">{children}</div>;
};
